import { createAsyncThunk } from '@reduxjs/toolkit'
import statusService from 'services/status'

// Returns the facility-facing PlatformStatus, or null when the endpoint can't
// be reached (the service swallows the error — unreachability is itself the
// signal the page renders).
export const getStatus = createAsyncThunk('status/get', () =>
  statusService.getStatus()
)
